import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PageHeaderComponent } from './page-header/page-header.component';
import { PageHeaderBreadcrumbComponent } from './page-header-breadcrumb/page-header-breadcrumb.component';
import { RefundFormComponent } from './refund-form/refund-form.component';
import { FlyOutComponent } from './fly-out/fly-out.component';
import { TryoutPageHeaderComponent } from './tryout-page-header/tryout-page-header.component';
import { TryoutPageHeaderBreadcrumbComponent } from './tryout-page-header-breadcrumb/tryout-page-header-breadcrumb.component';
import { TopThreeBoxComponent } from './top-three-box/top-three-box.component';
import { TermsAndAgreementsComponent } from './agreement-modal/agreement-modal.component';
import { CmodalComponent } from './cmodal/cmodal.component';
import { AddAnEventEmailComponent } from './add-an-event-email/add-an-event-email.component';
import { SendEmailFormComponent } from './send-email-form/send-email-form.component';
import { BuiltInModule } from '../built-in/built-in.module';
import { TgsFormComponent } from './tgs-form/tgs-form.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { PageHeaderNewComponent } from './page-header-new/page-header-new.component';
import { JuPageHeaderComponent } from './ju-page-header/ju-page-header.component';
import { FileDropZoneComponent } from './file-drop-zone/file-drop-zone.component';
import { TopBoxesComponent } from './top-boxes/top-boxes.component';
import { JLPdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { CurrentTeamsComponent } from './current-teams/current-teams.component';
import { RemoveModalComponent } from './remove-modal/remove-modal.component';
import { TableComponent } from './table/table.component';
import { MyprofileLeftNavComponent } from './myprofile-left-nav/myprofile-left-nav.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { ReadReceivedMessageComponent } from './read-received-message/read-received-message.component';
import { ReadDescriptionComponent } from './read-description/read-description.component';
import { RecurrenceEditorComponent } from './recurrence-editor/recurrence-editor.component';
import { TopBox3Component } from './app-top-boxes3/app-top-box3.component';
import { CollegeListGridComponent } from './college-list-grid/college-list-grid.component';
import { UsStatesVectorMapComponent } from './us-states-vector-map/us-states-vector-map.component';
import { FormDropZoneComponent } from './form-drop-zone/form-drop-zone.component';
import { EmailToComponent } from './email-to/email-to.component';
import { TeamPlayersFlyoutComponent } from './team-players-flyout/team-players-flyout.component';
import { AddPlayerModule } from './add-player/add-player.module';
import { TopFourBoxesComponent } from './top-four-boxes/top-four-boxes.component';
import { VideoModalComponent } from './video-modal/video-modal.component';
import { TGSImageCropperComponent } from './image-cropper/image-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InjuryHistoryComponent } from '../../pages/workouts/injury-history/injury-history.component';
import { InjuryFormComponent } from '../../pages/workouts/injury-form/injury-form.component';
import { AssignPlayerTeamComponent } from './assign-player-team/assign-player-team.component';

import { SubscriptionFlyOutComponent } from './subscription-fly-out/subscription-fly-out.component';
import { CommunicationCampaignFlyoutComponent } from '../../pages/sendgrid/communication-campaign-flyout/communication-campaign-flyout.component';
import { SendGridEmailHistoryComponent } from '../../pages/sendgrid/sendgrid-email-history/sendgrid-email-history.component';
import { FileDropZoneCampaignComponent } from './file-drop-zone-campaign/file-drop-zone-campaign.component';
import { MemberBillingInfoModule } from './member-billing-info/member-billing-info.module';
import { NewMessagesFlyoutComponent } from '../../pages/sendgrid/new-messages-flyout/new-messages-flyout.component';
import { MedicalQuestionsComponent } from './medical-questions/medical-questions.component';
import { TryoutCustomQuestionsComponent } from './tryout-custom-questions/tryout-custom-questions.component';
import { OurSystemStatusComponent } from './our-system-status/our-system-status.component';
import { SystemUpdateComponent } from './system-update/system-update.component';
import { ClubInjuryDetailsComponent } from './club-injury-details/club-injury-details.component';
import { CollegeSidelineCheckInComponent } from './college-sideline-checkin/college-sideline-checkin.component';
import { MemberSummaryComponent } from './member-summary/member-summary.component';
import { PipesModule } from '../pipes/pipes.module';
import { AllQuestionsComponent } from './questions/all-questions/all-questions.component';
import { QuestionsComponent } from './questions/questions.component';
import { AddPracticeComponent } from './add-practice/add-practice.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    BuiltInModule,
    ImageCropperModule,
    PipesModule,
  ],
  declarations: [
    PageHeaderComponent,
    PageHeaderBreadcrumbComponent,
    RefundFormComponent,
    FlyOutComponent,
    TryoutPageHeaderComponent,
    TryoutPageHeaderBreadcrumbComponent,
    TopThreeBoxComponent,
    CmodalComponent,
    TermsAndAgreementsComponent,
    SendEmailFormComponent,
    AddAnEventEmailComponent,
    TgsFormComponent,
    BreadcrumbComponent,
    PageHeaderNewComponent,
    JuPageHeaderComponent,
    TopBox3Component,
    FileDropZoneComponent,
    CollegeListGridComponent,
    UsStatesVectorMapComponent,
    FormDropZoneComponent,
    JLPdfViewerComponent,
    TopBoxesComponent,
    // PasswordValidator,
    MultiSelectComponent,
    CurrentTeamsComponent,
    RemoveModalComponent,
    TableComponent,
    MyprofileLeftNavComponent,
    DeleteModalComponent,
    InjuryHistoryComponent,
    SendGridEmailHistoryComponent,
    CommunicationCampaignFlyoutComponent,
    InjuryFormComponent,
    ReadReceivedMessageComponent,
    ReadDescriptionComponent,
    RecurrenceEditorComponent,
    EmailToComponent,
    TeamPlayersFlyoutComponent,
    TopFourBoxesComponent,
    VideoModalComponent,
    TGSImageCropperComponent,
    AssignPlayerTeamComponent,
    SubscriptionFlyOutComponent,
    FileDropZoneCampaignComponent,
    NewMessagesFlyoutComponent,
    MedicalQuestionsComponent,
    TryoutCustomQuestionsComponent,
    OurSystemStatusComponent,
    SystemUpdateComponent,
    ClubInjuryDetailsComponent,
    CollegeSidelineCheckInComponent,
    MemberSummaryComponent,
    QuestionsComponent,
    AllQuestionsComponent,
    AddPracticeComponent
  ],
  exports: [
    AddPlayerModule,
    MemberBillingInfoModule,
    PageHeaderComponent,
    BreadcrumbComponent,
    PageHeaderNewComponent,
    PageHeaderBreadcrumbComponent,
    RefundFormComponent,
    FlyOutComponent,
    TryoutPageHeaderComponent,
    TryoutPageHeaderBreadcrumbComponent,
    TopThreeBoxComponent,
    CmodalComponent,
    TermsAndAgreementsComponent,
    SendEmailFormComponent,
    AddAnEventEmailComponent,
    TgsFormComponent,
    JuPageHeaderComponent,
    TopBox3Component,
    // PasswordValidator,
    FileDropZoneComponent,
    CollegeListGridComponent,
    UsStatesVectorMapComponent,
    FormDropZoneComponent,
    JLPdfViewerComponent,
    TopBoxesComponent,
    MultiSelectComponent,
    CurrentTeamsComponent,
    RemoveModalComponent,
    TableComponent,
    MyprofileLeftNavComponent,
    DeleteModalComponent,
    InjuryHistoryComponent,
    SendGridEmailHistoryComponent,
    CommunicationCampaignFlyoutComponent,
    InjuryFormComponent,
    ReadReceivedMessageComponent,
    ReadDescriptionComponent,
    RecurrenceEditorComponent,
    EmailToComponent,
    TeamPlayersFlyoutComponent,
    TopFourBoxesComponent,
    VideoModalComponent,
    TGSImageCropperComponent,
    AssignPlayerTeamComponent,
    SubscriptionFlyOutComponent,
    FileDropZoneCampaignComponent,
    NewMessagesFlyoutComponent,
    MedicalQuestionsComponent,
    TryoutCustomQuestionsComponent,
    OurSystemStatusComponent,
    SystemUpdateComponent,
    ClubInjuryDetailsComponent,
    CollegeSidelineCheckInComponent,
    MemberSummaryComponent,
    QuestionsComponent,
    AllQuestionsComponent,
    AddPracticeComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/components.module.ts